
export default {
    name: 'show-stock',
    components: {},
    props: [],
    data () {
      return {
        entres_field: ['article', 'stock', 'initial' , 'nombre','date_peremption' ,'date'] 
      }
    },
    computed: {
      fournisseur() {
          return this.$store.getters['fournisseur']
      },
    },
    mounted () {
      this.$store.dispatch("getFournisseur", this.$route.params.id);
      
    },
    methods: {
  
    }
  }
  
  
  